module.exports = __webpack_public_path__ + "static/media/compress.b01e32d3.svg";